import base from "../base.js";
import animationDefinition from "../definition/animation.js";
import shadow from "../item/shadow.js";
import rotationDefinition from "../definition/rotation.js"

export default class ElementBase extends base {
    objectType = "ElementBase";
    Duration = 0;
    _Animation = null;
    _PressAnimation = null;
    Shadow = null;
    Rotation = null;
    _shadowStyle = "boxShadow";

    constructor(args = {}) {
        super(args);
    }

    objectToClassValue(args = {}) {
        super.objectToClassValue(args);
        this.Duration = args.duration != null ? args.duration : 5;
        this.Animation = args.animation ? this.getIdFromText(args.animation, animationDefinition) : this.getIdFromText("NONE", animationDefinition);
        this.PressAnimation = args.pressAnimation ? this.getIdFromText(args.pressAnimation, animationDefinition) : this.getIdFromText("NONE", animationDefinition);
        this.Shadow = args.shadow ? args.shadow : null;
        if (this.Shadow)
            this.Shadow.parent = this;
        if (args.rotation && args.rotation == "None")
            args.rotation = "NONE";
        this.Rotation = args.rotation ? this.getIdFromText(args.rotation, rotationDefinition) : this.getIdFromText("NONE", rotationDefinition);
    }

    static variableOfInstance() {
        return [
            ...super.variableOfInstance(),
            { property: "Duration", construct: Number, jsType: "Number" },
            { property: "Animation", construct: Number, jsType: "Number" },
            { property: "PressAnimation", construct: Number, jsType: "Number" },
            { property: "Shadow", construct: shadow, jsType: "Class" },
            { property: "Rotation", construct: Number, jsType: "Number" },
        ];
    }

    static get Name() {
        return "BaseElement";
    }

    get RotationName() {
        const rotation = rotationDefinition.find(rotation => rotation.idSoft == this.Rotation);
        if (rotation) {
            return rotation.name;
        }
        return null;
    }

    get RotationValue() {
        const rotation = rotationDefinition.find(rotation => rotation.idSoft == this.Rotation);
        if (rotation) {
            return rotation.value;
        }
        return null;
    }

    get shortCut() {
        return [...super.shortCut];
    }

    get AnimationName() {
        const animation = animationDefinition.find(animation => animation.idSoft == this.Animation);
        if (animation) {
            return animation.name;
        }
        return null;
    }

    get Animation() {
        return this._Animation;
    }

    set Animation(value) {
        this._Animation = value;
        this.playAnimation = true;
    }

    get PressAnimationName() {
        const animation = animationDefinition.find(animation => animation.idSoft == this.PressAnimation);
        if (animation) {
            return animation.name;
        }
        return null;
    }

    get PressAnimation() {
        return this._PressAnimation;
    }

    set PressAnimation(value) {
        this._PressAnimation = value;
        this.playPressAnimation = true;
    }

    getPosition(style) {
        const sizeParent = this.getParentSize();
        const r = rotationDefinition.find(rotation => rotation.idSoft == this.Rotation);
        if (r) {
            style = r.action(sizeParent, style);
        }
        return style;
    }

    getStyleOnlyPosition(currentElementIndex = null) {
        const sizeParent = this.getParentSize();
        let style = {
            width: sizeParent.width + "px",
            height: sizeParent.height + "px",
            top: "0px",
            left: "0px",
            opacity: this.Show ? 1 : 0,
            position: 'absolute',
        }
        return style;
    }

    getStyle(currentElementIndex = null) {
        let shadowImage = {};
        if (this.Shadow != null) {
            shadowImage = this.Shadow.getShadowStyle(this._shadowStyle);
        }
        let style = {
            ...shadowImage,
            ...super.getStyle(currentElementIndex),
        }
        style = this.getPosition(style);
        return style;
    }

    get changeableProperty() {
        const parentProperty = super.changeableProperty;
        return [
            ...parentProperty.filter(el => el.type != "objectInput" && el.type != "arrayInput"),
            ...(this.parent?.objectType == 'DiaporamaElement' ? [{ name: "Duration", text: "Durée", type: "numberInput", dataType: "number" }] : []),
            { name: "Animation", text: "Animation en arrivée de page", type: "selectInput", dataType: "string", options: animationDefinition, optionsType: "idSoft" },
            { name: "PressAnimation", text: "Animation sur clic", type: "selectInput", dataType: "string", options: animationDefinition, optionsType: "idSoft" },
            { name: "Rotation", text: "Rotation de l'élément", type: "selectInput", dataType: "string", options: rotationDefinition, optionsType: "idSoft" },
            { name: "Shadow", text: "Ombre", type: "objectInput", dataType: "object", options: shadow },
            ...parentProperty.filter(el => el.type == "objectInput" || el.type == "arrayInput")
        ];
    }

    static fromObjectToObject(object) {
        object = super.fromObjectToObject(object);
        if (object.shadow)
            object.shadow = shadow.fromObject(object?.shadow)
        return object;
    }

    toObject(minify = false) {
        return {
            ...super.toObject(minify),
            objectType: this.objectType,
            duration: this.Duration,
            animation: this.AnimationName,
            pressAnimation: this.PressAnimationName,
            shadow: this.Shadow ? this.Shadow.toObject(minify) : null,
            rotation: this.RotationName,
        }
    }

    toExportObject(variableArray = [], ressourceArray = []) {
        return {
            ...super.toExportObject(variableArray, ressourceArray),
            duration: this.Duration,
            animation: this.AnimationName,
            pressAnimation: this.PressAnimationName,
            shadow: this.Shadow ? this.Shadow.toExportObject(variableArray, ressourceArray) : null,
            rotation: this.RotationName,
        };
    }

    getFromPreviewId(id) {
        if (super.hasPreviewId(id) == true)
            return this;
        if (this.Shadow != null) {
            return this.Shadow.getFromPreviewId(id);
        }
        return null;
    }
}
